/* eslint-disable react/prop-types */
import { Alert, Box, Collapse, LinearProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

interface CustomMassApprovallProgressSnackbarProps {
	progress: number
	isOpen: boolean
}

/**
 * ## CustomMassApprovallProgressSnackbar component
 *
 * - @param {CustomMassApprovallProgressSnackbarProps} progress - The progress value to display
 * - @param {CustomMassApprovallProgressSnackbarProps} isOpen - The open state of the snackbar
 * - @returns {JSX.Element} The rendered CustomMassApprovallProgressSnackbar component
 */
const CustomMassApprovallProgressSnackbar: React.FC<CustomMassApprovallProgressSnackbarProps> = ({
	progress,
	isOpen,
}) => {
	const [open, setOpen] = useState(isOpen)

	// Close snackbar when progress reaches 100%
	useEffect(() => {
		if (isOpen && !open && progress >= 0) setOpen(true)
		if (progress >= 100) setOpen(false)
	}, [progress, isOpen])

	if (open === false) return null

	return (
		<Box sx={{ width: '100%', position: 'absolute', top: '-24px', left: 0, zIndex: 999 }}>
			<Collapse
				in={open}
				timeout={150}
				easing={'ease'}
				exit={true}
			>
				<Alert
					variant='filled'
					severity='info'
					color='info'
					title='A aprovar Folhas de Ponto sem alterações...'
					aria-description='Snackbar de aprovação em massa bem-sucedida'
					sx={{
						height: '37px',
						padding: '0 16px',
						display: 'flex',
						alignItems: 'center',
						background: '#E5F6FD',
						fontFamily: 'var(--font-family)',
						fontSize: '14px',
						fontWeight: 500,
						letterSpacing: '0.15px',
						lineHeight: '150%',
						'& .MuiAlert-icon': {
							color: '#0288D1',
						},
						'& .MuiAlert-message': {
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: '1rem',
							flex: 1,
						},
						'& .MuiAlert-action': {
							width: 'fit-content !important',
						},
					}}
				>
					<Typography
						sx={{
							width: '670px',
							margin: 0,
							marginRight: 'auto',
							color: 'var(--primary-dark)',
							fontFamily: 'Poppins, sans-serif',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: 500,
							letterSpacing: '0.15px',
							lineHeight: '150%',
						}}
					>
						A aprovar Folhas de Ponto sem alterações...
					</Typography>
					<Box sx={{ width: '150px', mr: 1 }}>
						<LinearProgress
							variant='determinate'
							value={progress}
						/>
					</Box>
					<Box sx={{ minWidth: 35 }}>
						<Typography
							variant='body2'
							sx={{ color: '#014361' }}
						>{`${Math.round(progress)}%`}</Typography>
					</Box>
				</Alert>
			</Collapse>
		</Box>
	)
}

export default CustomMassApprovallProgressSnackbar
